import { EmployeeNode } from './employee-node';
import { ColorConfig } from './../../../color-config';
import { EnumConfig } from './../../../../data-management/enum-config';
import { Geometry } from './../../../../util/geometry';
import * as Snap from 'snapsvg-cjs';

export abstract class ConsultantNode extends EmployeeNode {
    private svgExperienceCircle: any;
    private innerCirclePart: any;

    protected redraw() {
        const matrix = new Snap.Matrix();
        const biasedSize = this.layoutNode.pixelR * 0.95;
        const scaledSizeSymbol = (biasedSize * 2) / this.organigram.organigramSize;
        matrix.translate(
            this.layoutNode.pixelX - (this.layoutNode.pixelR * this.organigram.width) / this.organigram.organigramSize,
            this.layoutNode.pixelY - (this.layoutNode.pixelR * this.organigram.height) / this.organigram.organigramSize
        );
        matrix.scale(scaledSizeSymbol, scaledSizeSymbol);

        this.svgSymbol.transform(matrix);
        this.svgSymbol.attr({
            x: this.layoutNode.pixelX,
            y: this.layoutNode.pixelY,
            width: this.layoutNode.pixelR,
            height: this.layoutNode.pixelR
        });

        this.svgExperienceCircle.attr({
            cx: this.layoutNode.pixelX,
            cy: this.layoutNode.pixelY,
            r: this.layoutNode.pixelR * 0.4
        });
        this.redrawExperience();
        this.repositionText();
    }

    protected refreshColors() {
        this.svgSymbol.selectAll('path').attr({
            fill: this.fill,
            stroke: this.stroke,
            'stroke-width': this.strokeWidth
        });
    }

    protected setSelected() {
        this.enableText();
        this.setColors(ColorConfig.organigramConsultantSelected, ColorConfig.organigramConsultantSelectedBorder);
    }

    // protected setHovered() {
    //     this.setColors(ColorConfig.organigramConsultantNormal, ColorConfig.organigramConsultantSelectedBorder)
    // }

    protected initdrawexperience() {
        this.svgExperienceCircle = this.organigram.snap.circle(
            this.layoutNode.pixelX,
            this.layoutNode.pixelY,
            this.layoutNode.pixelR * 0.4
        );
        this.svgExperienceCircle.attr({
            fill: 'rgba(0,0,0,0.1)',
            'pointer-events': 'none'
        });
        this.redrawExperience();
    }

    private redrawExperience() {
        if (this.innerCirclePart) {
            this.innerCirclePart.remove();
        }
        const maxConsultantValue = Math.max(
            ...Object.keys(EnumConfig.seniorLevels).map(key => EnumConfig.seniorLevels[key])
        );
        if (EnumConfig.seniorLevels[this.data.FunctionLevel]) {
            if (EnumConfig.seniorLevels[this.data.FunctionLevel] !== maxConsultantValue) {
                const consultantValueBias = EnumConfig.seniorLevels[this.data.FunctionLevel] / maxConsultantValue;
                const cx = this.layoutNode.pixelX;
                const cy = this.layoutNode.pixelY;
                const r: number = this.layoutNode.pixelR * 0.4;
                const x1: number = cx - r;
                const y1: number = cy + r - r * 2 * consultantValueBias;
                const x2: number = cx + r;
                const y2: number = y1;
                const flipCircle: number = y1 > cy ? 0 : 1;
                const intersections = Geometry.getIntersections([x1, y1], [x2, y2], [cx, cy, r]);
                const i1: number[] = intersections.points.intersection1.coords;
                const i2: number[] = intersections.points.intersection2.coords;

                this.innerCirclePart = this.organigram.snap
                    .path(
                        'M' +
                            i1[0] +
                            ',' +
                            i1[1] +
                            ' a' +
                            r +
                            ',' +
                            r +
                            ' 0 ' +
                            flipCircle +
                            ',0 ' +
                            (i2[0] - i1[0]) +
                            ',' +
                            (i2[1] - i1[1])
                    )
                    .attr({
                        fill: 'rgba(0,0,0,0.5)',
                        'pointer-events': 'none'
                    });
            } else {
                this.innerCirclePart = this.organigram.snap.circle(
                    this.layoutNode.pixelX,
                    this.layoutNode.pixelY,
                    this.layoutNode.pixelR * 0.4
                );
                this.innerCirclePart.attr({
                    fill: 'rgba(0,0,0,0.5)',
                    'pointer-events': 'none'
                });
            }
        }
    }
}
